import Swal from "sweetalert2";
const showAlert = (type, msg) => {
  return Swal.fire({
    icon: type,
    title: msg,
  });
};

export default showAlert;
